module.exports = __webpack_public_path__ + "img/module2_icon3.8ae4adf5.png";